module.exports = __webpack_public_path__ + "img/img81.c5c0d52e.png";